import React, { Fragment } from 'react';
import Accounting from './Accounting.js';
import Purchasing from './Purchasing.js';
import Pharmacy from './Pharmacy.js';
import Secretary from './Secretary.js';
import AuthorizedPurchasePerson from './AuthorizedPurchasePerson.js';
import AuthorizedReceivedPerson from './AuthorizedReceivedPerson';

function BusinessContacts({
  customer,
  form,
  handleChange,

  authPersonToReceiveFunction,
  authPersonToReceive,
  authPersonToPurchase,
  authPersonToPurchaseFunction,
}) {
  /**
   * ESCM-13070: every block below is now hidden — Secretary Contact Information
   * was the last one left and it moved into the Account Information table (the
   * "Set as Secretary" column). Nothing renders, so the whole fieldset is
   * suppressed. Flip this back to a real condition if any block below returns.
   */
  const hasContent = false;

  if (!hasContent) return null;

  return (
    <Fragment>
      <fieldset className="details-field-set mb-4 mt-0">
        <legend>Business Contacts</legend>
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-6">
              {form.customer_type !== 4 ? (
                <Fragment>
                  {/* Hidden: Account Contact Information (replaced by Account Information table) */}
                  {/* <Accounting form={form} handleChange={handleChange} /> */}
                  {/* Hidden: Purchasing / Pharmacy Contact Information (ESCM-13193 — replaced by Account Information table) */}
                  {/* <Purchasing form={form} handleChange={handleChange} /> */}
                  {/* <Pharmacy form={form} handleChange={handleChange} /> */}
                </Fragment>
              ) : (
                <Fragment>
                  {/* Hidden: Secretary Contact Information (ESCM-13070 — replaced by the "Set as Secretary" column of the Account Information table) */}
                  {/* <Secretary form={form} handleChange={handleChange} /> */}
                </Fragment>
              )}
            </div>
            <div className="col-md-6">
              <div className="row">
                {/* Hidden: Authorized Person To Purchase / To Received (ESCM-13193 — replaced by Account Information table) */}
                {/* <AuthorizedPurchasePerson
                  form={form}
                  handleChange={handleChange}
                  handleCheck={authPersonToPurchaseFunction}
                  dataStatus={authPersonToPurchase}
                /> */}
                {/* <AuthorizedReceivedPerson
                  form={form}
                  handleChange={handleChange}
                  handleCheck={authPersonToReceiveFunction}
                  dataStatus={authPersonToReceive}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </Fragment>
  );
}

export default BusinessContacts;
